import React, { useEffect } from 'react'
import { faSlidersSolid } from '@/lib/fa'
import CheckboxWithLabelField from '@/modules/drivers/forms/contract/inputs/CheckboxWithLabelField'
import StageHeader from '@/modules/drivers/forms/shared/StageHeader'
import { DividerHorizontal } from '@/modules/drivers/shared/DividerHorizontal'
import { DateField } from '@/ui/form/controls/DateField'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import { DatePickerRangeProps } from '@/modules/drivers/types'
import { useRaportForm } from '../../context/RaportFormContext'
import Options from './stages/Options'
import {
  RANGE_OVERRIDE_END,
  RANGE_OVERRIDE_START,
  toInputDate,
} from '../../utils/printoutRangeOverride'

const LeaveApplication = ({
  defaultRange,
}: {
  defaultRange?: DatePickerRangeProps
}) => {
  const { data, setData } = useRaportForm()
  const { t } = useLocalize()

  useEffect(() => {
    setData({
      period: true,
      separateFiles: false,
      issuerSignature: false,
      driverSignature: false,
      [RANGE_OVERRIDE_START]: toInputDate(defaultRange?.startDate),
      [RANGE_OVERRIDE_END]: toInputDate(defaultRange?.endDate),
    })
  }, [])

  const forSettlementPeriod = data?.period !== false
  const rangeStart = data?.[RANGE_OVERRIDE_START] ?? ''
  const rangeEnd = data?.[RANGE_OVERRIDE_END] ?? ''
  const rangeInvalid = Boolean(rangeStart && rangeEnd && rangeStart > rangeEnd)

  const setPeriod = (period: boolean) => setData({ ...data, period })

  const setRangeDate = (field: string) => (value: string | null) =>
    setData({ ...data, [field]: value ?? '' })

  return (
    <div className="tw-flex-1 tw-space-y-4 tw-overflow-auto tw-p-4 tw-pr-8">
      <div className="tw-flex tw-items-start">
        <StageHeader
          title={t('printout.period')}
          textSize="sm"
          icon={faSlidersSolid}
        />
        <div className="tw-flex tw-flex-1 tw-flex-col tw-gap-1 sm:tw-min-w-[400px]">
          <CheckboxWithLabelField
            label={t('printout.printTimesheetForSettlementPeriod')}
            value={forSettlementPeriod}
            onChange={() => setPeriod(true)}
          />
          <CheckboxWithLabelField
            label={t('printout.printTimesheetForSelectedMonths')}
            value={!forSettlementPeriod}
            onChange={() => setPeriod(false)}
          >
            <div className="tw-flex tw-flex-col">
              <div className="tw-flex tw-items-start tw-gap-3">
                <DateField
                  label={t('printout.date-from')}
                  inputSize="small"
                  classNameWrapper="tw-flex-1"
                  value={rangeStart}
                  setValue={setRangeDate(RANGE_OVERRIDE_START)}
                />
                <DateField
                  label={t('printout.date-to')}
                  inputSize="small"
                  classNameWrapper="tw-flex-1"
                  value={rangeEnd}
                  setValue={setRangeDate(RANGE_OVERRIDE_END)}
                />
              </div>
     
              <p
                className={`tw-m-0 tw-h-4 tw-whitespace-nowrap tw-text-[11px] tw-leading-4 tw-text-error ${
                  rangeInvalid ? '' : 'tw-invisible'
                }`}
              >
                {t('printout.date-range-invalid')}
              </p>
            </div>
          </CheckboxWithLabelField>
        </div>
      </div>
      <DividerHorizontal />
      <Options
        setData={setData}
        data={data}
        vehicleActivity={false}
        separateFilesOnly
      />
    </div>
  )
}

export default LeaveApplication
